import { AlertTriangle } from "lucide-react";
import { cn } from "@/lib/cn";

/** "Aguardando Confirmação" → "Aguardando confirmação": caixa alta em 10px era pequena e gritada. */
export const fraseNormal = (t: string) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();

/**
 * Situação de pedido ou serviço: bolinha na cor + texto em caixa normal, 12px. Fica sempre à direita
 * do que descreve, e não tem cara de botão (nada de borda ou sombra).
 */
export function PilulaDeStatus({
  rotulo,
  cor,
  fundo,
  alerta,
  className,
}: {
  rotulo: string;
  cor: string;
  fundo: string;
  /** Retrabalho aberto: o triângulo diz que há algo pendente além do status. */
  alerta?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn("inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium", className)}
      style={{ backgroundColor: fundo, color: cor }}
    >
      {alerta ? <AlertTriangle className="h-3 w-3" /> : <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: cor }} />}
      {fraseNormal(rotulo)}
    </span>
  );
}
